export function TitleCtn({ tituloVitrine }: { tituloVitrine: string | null }) {
    return (
        tituloVitrine && (
            <div className="title-ctn">
                <h2 className="bg-title">
                <span dangerouslySetInnerHTML={{ __html: tituloVitrine }} />
                </h2>
            </div>
        )
    )
}